/* unplugin-vue-components disabled */module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"days":"{n} дней | {n} день | {n} дня | {n} дней"}}')
  delete Component.options._Ctor
}
